import React, { useEffect, useRef, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Share from "yet-another-react-lightbox/plugins/share";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Video from "yet-another-react-lightbox/plugins/video";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { Fade } from "react-awesome-reveal";
import { useGalleryImageContext } from "../../context/GalleryContext";
interface IGalleryID {
  id: number;
}

const GalleryGrid = (props: IGalleryID) => {
  const [open, setOpen] = useState(false);
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const weekday = new Intl.DateTimeFormat("en-GB", {
      weekday: "long",
    }).format(date);
    const formattedDate = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(date);
    return `${weekday}, ${formattedDate}`;
  };
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const galleryGridRef = useRef<HTMLDivElement>(null);
  const { galleryImageData } = useGalleryImageContext();
  const images = galleryImageData?.map((data) => {
    return {
      id: data?.id,
      title: data?.title,
      date: data?.date,
      image: data?.images?.map((img) => img?.media?.url),
    };
  });
  const filteredGallery = images.find((img) => img.id === props.id);
  useEffect(() => {
    if (props.id !== undefined) {
      galleryGridRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [props.id]);

  if (!filteredGallery) {
    return <p>No gallery found for this ID.</p>;
  }

  const lightboxSlides = filteredGallery.image.map((src) => ({
    src: src
      ? `${process.env.REACT_APP_cmsUrl}${src}`
      : "https://dashboard.scieverinc.com.np/uploads/logo_white3_747fc8e5de.png",
  }));
  const handleSlideClick = (index: number) => {
    setLightboxIndex(index);
    setOpen(true);
  };
  return (
    <>
      <div ref={galleryGridRef}></div>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-8a8a326 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8a8a326"
        data-element_type="section"
        data-settings='{"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
      >
        <div className="elementor-container elementor-column-gap-default">
          <div className="elementor-row">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d3af3af"
              data-id="d3af3af"
              data-element_type="column"
              data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
            >
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap">
                  <Fade cascade damping={0.2} direction="up" triggerOnce={true}>
                    <div
                      className="elementor-element elementor-element-87813e2 elementor-widget elementor-widget-heading"
                      data-id="87813e2"
                      data-element_type="widget"
                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h6 className="back-to-album-h3">
                          <div
                            className="back-to-album"
                            onClick={(e) => {
                              e.preventDefault();
                              window.history.back();
                            }}
                          >
                            <span className="ti-arrow-left arrow-left"></span>
                            &nbsp; Back to Album
                          </div>
                        </h6>
                        <h2 className="elementor-heading-title elementor-size-default">
                          {filteredGallery.title}
                        </h2>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-49bf8cd elementor-widget elementor-widget-text-editor"
                      data-id="49bf8cd"
                      data-element_type="widget"
                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <div className="elementor-text-editor elementor-clearfix">
                          <p>{formatDate(filteredGallery.date)}</p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                  <div
                    className="elementor-element elementor-element-c222a70 elementor-widget elementor-widget-hoteller-gallery-grid"
                    data-id="c222a70"
                    data-element_type="widget"
                    data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                    data-widget_type="hoteller-gallery-grid.default"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div className="elementor-widget-container">
                      <div
                        className="gallery_grid_content_wrapper layout_tg_three_cols custom-layout_tg_three_cols"
                        style={{
                          display: "grid",
                          gap: "20px",
                          padding: "0% 15%",
                          gridTemplateColumns: "repeat(3, 1fr)",
                        }}
                      >
                        {filteredGallery.image.map((image, index) => (
                          <Fade
                            cascade
                            damping={0.2}
                            direction="up"
                            triggerOnce={true}
                          >
                            <div
                              className="gallery_grid_item tg_three_cols gallery-grid-tilt"
                              style={{
                                position: "relative",
                                cursor: "pointer",
                              }}
                              onClick={() => handleSlideClick(index)}
                            >
                              {/* <a
                              className="tg_gallery_lightbox"
                              href="upload/a-black-and-white-bachelor-pad-in-brooklyn-home-tour-lonny-for-brownstone-apartment-designer-dan-mazzarini-melded-historic-architecture-modern-masculine_hotel-inter-2.jpg"
                              data-thumb="upload/a-black-and-white-bachelor-pad-in-brooklyn-home-tour-lonny-for-brownstone-apartment-designer-dan-mazzarini-melded-historic-architecture-modern-masculine_hotel-interior-black-and-white_hotel_hotel-desi-300x200.jpg"
                              data-rel="tg_galleryc222a70"
                            > */}
                              <img
                                src={
                                  image
                                    ? `${process.env.REACT_APP_cmsUrl}${image}`
                                    : "https://dashboard.scieverinc.com.np/uploads/logo_white3_747fc8e5de.png"
                                }
                                alt="gallery"
                                style={{
                                  width: "100%",
                                  height: "350px",
                                  objectFit: "cover",
                                }}
                              />
                              <div className="custom-gradient"></div>
                              {/* </a> */}
                            </div>
                          </Fade>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Lightbox
        open={open}
        plugins={[
          Counter,
          Fullscreen,
          Share,
          Slideshow,
          Video,
          Zoom,
          Thumbnails,
        ]}
        close={() => setOpen(false)}
        slides={lightboxSlides}
        index={lightboxIndex}
      />
    </>
  );
};

export default GalleryGrid;
